import { useAuth } from '../context/AuthContext'
import { useLanguage, useTranslation } from '../i18n'

export function UserMenu() {
  const { user, isAuthenticated, isLoading, login, logout } = useAuth()
  const { language, setLanguage, availableLanguages } = useLanguage()
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <div className="user-menu user-menu--loading" data-testid="user-menu-loading">
        <i className="pi pi-spin pi-spinner" />
      </div>
    )
  }

  const nextLanguage = availableLanguages.find((l) => l.code !== language) ?? availableLanguages[0]
  const currentLanguage =
    availableLanguages.find((l) => l.code === language) ?? availableLanguages[0]

  const languageSelector = (
    <button
      className="user-menu__language"
      data-testid="language-selector"
      onClick={() => setLanguage(nextLanguage.code)}
      aria-label={t('label.language')}
    >
      <i className="pi pi-globe" aria-hidden="true" />
      <span data-testid="language-select">{currentLanguage.name}</span>
    </button>
  )

  if (!isAuthenticated) {
    return (
      <div className="user-menu" data-testid="user-menu">
        {languageSelector}
        <button
          className="nav-link user-menu__login"
          onClick={login}
          data-testid="login-button"
          aria-label={t('button.login')}
        >
          <i className="pi pi-sign-in" aria-hidden="true" />
          <span>{t('button.login')}</span>
        </button>
      </div>
    )
  }

  return (
    <div className="user-menu" data-testid="user-menu">
      {languageSelector}
      <span className="user-menu__name" data-testid="user-name">
        <i className="pi pi-user" aria-hidden="true" />
        <span>{user?.username}</span>
      </span>
      <button
        className="nav-link user-menu__logout"
        onClick={logout}
        data-testid="logout-button"
        aria-label={t('button.logout')}
      >
        <i className="pi pi-sign-out" aria-hidden="true" />
        <span>{t('button.logout')}</span>
      </button>
    </div>
  )
}
